import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import { GrupoMotivoPerda } from 'src/app/models/grupo-motivo-perda';
import { MotivoPerda } from 'src/app/models/motivo-perda';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { GrupoMotivoPerdaService } from 'src/app/services/grupo-motivo-perda.service';
import { MotivoPerdaService } from 'src/app/services/motivo-perda.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { MaskedNumber } from "imask";

@Component({
  selector: 'app-cadastrar-motivo-perda-orc',
  templateUrl: './cadastrar-motivo-perda-orc.component.html',
  styleUrls: ['./cadastrar-motivo-perda-orc.component.scss']
})
export class CadastrarMotivoPerdaOrcComponent implements OnInit {

  // variáveis
  idMotivoPerda;
  motivoPerda: MotivoPerda = {
    id: 0,
    descricao: '',
    grupo: '',
    idGrupoMP: null
  };

  editando = false;
  carregando = true;
  public MASKS = MASKS;
  grupos: GrupoMotivoPerda[] = [];

  motivoFormControl: FormGroup;
  motivoFormData: FormGroup;

  public readonly MaskedNumber = MaskedNumber

  constructor(
   private route: ActivatedRoute,
   private notificacaoService: NotificacaoService,
   private motivoPerdaService: MotivoPerdaService,
   private router: Router,
   private globalService: GlobalService,
   private carregandoService: CarregandoService,
   private gruposMotivoPerdaService: GrupoMotivoPerdaService
  ) {
    this.createReactiveForm();
   }

  ngOnInit() {
    this.buscarGruposMotivoPerda();

    // se for edição, busca o motivoPerda do id passado
    if (this.route.snapshot.paramMap.get('id')) {
      this.idMotivoPerda = this.route.snapshot.paramMap.get('id');
      this.editando = true;
      this.buscarMotivoPerda();
    } else {
      this.motivoFormControl.reset();
      this.motivoFormData.reset(this.motivoPerda);
    }  }

  createReactiveForm() {
    this.motivoFormData = new FormGroup({
      id: new FormControl(this.motivoPerda.id),
      descricao: new FormControl(this.motivoPerda.descricao, Validators.required),
      idGrupoMP: new FormControl(this.motivoPerda.idGrupoMP),
      grupo: new FormControl(this.motivoPerda.grupo)
    }, {});
  }

  ngAfterViewInit(): void {}

  buscarMotivoPerda() {
    this.carregandoService.mostra('buscaMotivoPerda');

    this.motivoPerdaService.consultarPorId(this.idMotivoPerda).subscribe((age) => {
      this.motivoFormData.setValue({
        ...age,
        grupo: ''
      });

      this.carregandoService.esconde('buscaMotivoPerda');
    }, (erro) => {
      this.carregandoService.esconde('buscaMotivoPerda');
      this.notificacaoService.erro(erro);
    });
  }

  buscarGruposMotivoPerda() {
    this.carregandoService.mostra('buscaGrupos');
    this.gruposMotivoPerdaService.buscarTodos().subscribe(data => {
      this.grupos = data;
      this.carregandoService.esconde('buscaGrupos');
    }, (erro) => {
      this.notificacaoService.erro('Não foi possível buscar os grupos');
      this.carregandoService.esconde('buscaGrupos');
    });
  }

  salvar() {
    this.carregandoService.mostra('salvaMotivoPerda');
    const motivo = this.motivoFormData.getRawValue();

    this.motivoPerdaService.salvar(motivo).subscribe(() => {
      this.notificacaoService.sucesso('Motivo de perda salvo com sucesso!!!');
      this.router.navigate(['configuracoes/motivo-perda']).then(() => {
        this.carregandoService.esconde('salvaMotivoPerda');
      });

    }, (erro) => {
      this.carregandoService.esconde('salvaMotivoPerda');
      this.notificacaoService.erro(erro);
    });
  }

  ngOnDestroy(): void { }
}
